import { Form, Select } from 'antd'
import { FormComponentProps } from 'antd/lib/form'
import React from 'react'
import styles from './SelectInput.module.scss'

interface IProps extends FormComponentProps {
  key?: any
  rules?: any[]
  label: React.ReactNode
  options?: any[]
  name: string
  onChange?: any
  disabled?: boolean
  inputProps?: any
  placeholder?: string
  classNameInput?: any
  initialValue?: any
  loading?: boolean
}

const SelectInput: React.FC<IProps> = (props: IProps) => {
  const { form, rules = [], label, options = [], name, onChange, disabled = false, inputProps, placeholder, classNameInput, initialValue, loading } = props

  const { getFieldDecorator } = form
  const [isRequired, setIsRequired] = React.useState(false)

  React.useEffect(() => {
    if (rules && rules.length && !isRequired) {
      setIsRequired(rules.find((item) => item.required === true))
    }
  }, [rules, isRequired, form])

  const handlerChange = (value: any) => {
    onChange && onChange(value)
  }

  const inputOptions = {
    rules,
    ...(initialValue ? { initialValue } : {}),
  } as any

  const isValidReactElement = (element: any): element is React.ReactElement => {
    return React.isValidElement(element)
  }

  return (
    <Form.Item className={`${styles.input} ${classNameInput || ''}`} key={`${name}-formItem`} label={label} required={isRequired}>
      {getFieldDecorator(
        name,
        inputOptions
      )(
        !isValidReactElement(options) ? (
          <Select disabled={disabled} key={`${name}-select`} loading={loading} placeholder={placeholder || label} onChange={handlerChange} {...inputProps}>
            {options?.map((option) => {
              if (React.isValidElement(option)) {
                return option
              }

              return option && Object.keys(option).length ? (
                <Select.Option disabled={option?.disabled} key={option.value} value={option.value} {...option.props}>
                  {option.label}
                </Select.Option>
              ) : null
            })}
          </Select>
        ) : (
          options
        )
      )}
    </Form.Item>
  )
}

export default SelectInput
